import type { QuoteRequest } from '@/types';

export const requests: QuoteRequest[] = [
  {
    id: 'TR-2026-0112',
    customerName: 'Mehmet Demir',
    phone: '0533 214 55 87',
    service: 'İnşaat Sonrası Temizlik',
    region: 'Silivri',
    requestDate: '24 Ağustos 2026',
    videoStatus: 'Video Geldi',
    status: 'Video Geldi',
    source: 'WhatsApp',
    responsible: 'Burak Yıldız',
    lastContact: 'Bugün 08:40',
    priority: 'Yüksek',
    propertyType: 'Müstakil Ev',
    area: '320 m²',
    customerNote: 'Yeni inşaat bitti, boya sonrası ince temizlik istiyorum.',
    addressNote: 'Site girişinden sol taraftaki 3. ev.',
    activities: [
      { time: '24.08 09:42', text: 'Talep geldi (WhatsApp)' },
      { time: '24.08 10:05', text: 'Video gönderildi' },
      { time: 'Bugün 08:40', text: 'Video incelendi — teklif bekleniyor' },
    ],
  },
  {
    id: 'TR-2026-0109',
    customerName: 'Selin Kaya',
    phone: '0542 789 32 11',
    service: 'Residence Temizliği',
    region: 'İstanbul Anadolu',
    requestDate: '21 Ağustos 2026',
    videoStatus: 'Video Geldi',
    status: 'Müşteri Cevabı Bekleniyor',
    source: 'Instagram',
    responsible: 'Deniz Acar',
    lastContact: '2 gün önce',
    priority: 'Yüksek',
    propertyType: 'Rezidans Daire',
    area: '150 m²',
    customerNote: '3+1 rezidans, eşyalı. Taşınmadan önce detaylı temizlik.',
    addressNote: 'A Blok 14. kat.',
    activities: [
      { time: '21.08 13:20', text: 'Talep geldi (Instagram)' },
      { time: '21.08 14:00', text: 'Video gönderildi' },
      { time: '22.08 10:40', text: 'Teklif hazırlandı (12.000 TL)' },
      { time: '22.08 10:45', text: 'Teklif gönderildi' },
      { time: '23.08 09:00', text: 'Cevap bekleniyor' },
    ],
  },
  {
    id: 'TR-2026-0108',
    customerName: 'Ayşe Yılmaz',
    phone: '0532 456 78 90',
    service: 'Villa Detaylı Temizlik',
    region: 'İstanbul Anadolu',
    requestDate: '19 Ağustos 2026',
    videoStatus: 'Video Geldi',
    status: 'Onaylandı',
    source: 'Referans',
    responsible: 'Burak Yıldız',
    lastContact: 'Bugün 09:10',
    priority: 'Normal',
    propertyType: 'Villa',
    area: '280 m²',
    customerNote: 'Dönemsel derinlemesine temizlik, 2 katlı villa.',
    addressNote: 'Ana kapıdan girin, anahtar komşuda.',
    activities: [
      { time: '19.08 11:10', text: 'Talep geldi (Referans)' },
      { time: '19.08 12:00', text: 'Video gönderildi' },
      { time: '20.08 15:30', text: 'Teklif hazırlandı (18.500 TL)' },
      { time: '20.08 15:35', text: 'Teklif gönderildi' },
      { time: '21.08 13:20', text: 'Müşteri onayladı' },
      { time: 'Bugün 09:10', text: 'Randevu oluşturuldu — 10:00' },
    ],
  },
  {
    id: 'TR-2026-0113',
    customerName: 'Ahmet Çelik',
    phone: '0535 321 90 44',
    service: 'Plaza / Ofis Temizliği',
    region: 'İstanbul Avrupa',
    requestDate: '25 Ağustos 2026',
    videoStatus: 'Video Bekleniyor',
    status: 'Video Bekleniyor',
    source: 'Website',
    responsible: 'Ece Demirci',
    lastContact: 'Dün 17:20',
    priority: 'Orta',
    propertyType: 'Ofis Katı',
    area: '400 m²',
    customerNote: 'Aylık ofis temizliği için teklif istiyor.',
    addressNote: 'Plaza B girişi.',
    activities: [
      { time: '25.08 16:00', text: 'Talep geldi (Website)' },
      { time: '25.08 17:20', text: 'Video istendi — bekleniyor' },
    ],
  },
  {
    id: 'TR-2026-0114',
    customerName: 'Zeynep Arslan',
    phone: '0536 678 12 09',
    service: 'Yazlık Ev Temizliği',
    region: 'Tekirdağ',
    requestDate: '25 Ağustos 2026',
    videoStatus: 'Video Yok',
    status: 'Yeni Talep',
    source: 'Facebook',
    responsible: 'Kaan Arslan',
    lastContact: 'Dün 11:05',
    priority: 'Normal',
    propertyType: 'Yazlık',
    area: '120 m²',
    customerNote: 'Yazlık açılış temizliği, sezon başında.',
    addressNote: '',
    activities: [{ time: '25.08 11:05', text: 'Talep geldi (Facebook)' }],
  },
  {
    id: 'TR-2026-0110',
    customerName: 'Murat Öztürk',
    phone: '0541 902 67 31',
    service: 'Koltuk Yıkama',
    region: 'Ankara',
    requestDate: '22 Ağustos 2026',
    videoStatus: 'Video Geldi',
    status: 'Değerlendiriliyor',
    source: 'Referans',
    responsible: 'Deniz Acar',
    lastContact: '3 gün önce',
    priority: 'Orta',
    propertyType: 'Daire',
    area: '90 m²',
    customerNote: '3 koltuk + 2 koltuk takımı yıkama.',
    addressNote: '',
    activities: [
      { time: '22.08 10:00', text: 'Talep geldi (Referans)' },
      { time: '22.08 14:15', text: 'Video gönderildi' },
      { time: '23.08 09:30', text: 'Değerlendirme aşamasında' },
    ],
  },
  {
    id: 'TR-2026-0111',
    customerName: 'Elif Doğan',
    phone: '0537 450 88 26',
    service: 'Villa Temizliği',
    region: 'İstanbul Anadolu',
    requestDate: '21 Ağustos 2026',
    videoStatus: 'Video Geldi',
    status: 'Teklif Gönderildi',
    source: 'WhatsApp',
    responsible: 'Burak Yıldız',
    lastContact: 'Dün 18:00',
    priority: 'Orta',
    propertyType: 'Villa',
    area: '260 m²',
    customerNote: 'Düzenli müşteri, yine villa temizliği.',
    addressNote: 'Bilinen adres.',
    activities: [
      { time: '21.08 09:15', text: 'Talep geldi (WhatsApp)' },
      { time: '21.08 10:00', text: 'Video gönderildi' },
      { time: '24.08 16:00', text: 'Teklif hazırlandı (15.000 TL)' },
      { time: '24.08 16:10', text: 'Teklif gönderildi' },
    ],
  },
  {
    id: 'TR-2026-0107',
    customerName: 'Can Aksoy',
    phone: '0538 123 74 58',
    service: 'Residence Temizliği',
    region: 'İstanbul Avrupa',
    requestDate: '18 Ağustos 2026',
    videoStatus: 'Video Yok',
    status: 'Ulaşılamadı',
    source: 'Instagram',
    responsible: 'Ece Demirci',
    lastContact: '1 hafta önce',
    priority: 'Normal',
    propertyType: 'Rezidans Daire',
    area: '130 m²',
    customerNote: 'İlk kez iletişime geçti, henüz detay yok.',
    addressNote: '',
    activities: [
      { time: '18.08 12:00', text: 'Talep geldi (Instagram)' },
      { time: '18.08 12:30', text: 'Arama yapıldı — ulaşılamadı' },
    ],
  },
];